export default function HeatByHeatOverall(){
  
  const error = () => console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",)
  function acc() {
    $('.smx-acc .smx-acc-item .smx-acc-trigger').click(function(){
      $(this).parent().find('.smx-acc-content').slideToggle()
      $(this).find('i').toggleClass('active')
    })
  }
  
  if($('#hbh-overall').length){
    const eventUrl = window.location.pathname.split('/')
    const eventSanction = eventUrl[2] 
    const eventID = eventUrl[4]
    const eventName = eventUrl[5].replace(/-/g, ' ');
    const loaded = (target) => $(target).addClass('loaded')
    const containerMobile = $('#bl-container-mobile')
    const containerDesktop = $('#bl-container-desktop')

    function render(data){
      $(`#session-name`).html(`${data.ClassName} - ${data.EventName}`)
      const results = data.OverallResult
      let contentMobile = ``
      let contentDesktop = ``
      if(data.ClassAbr === 'XM'){
        $('#hbh-overall').addClass('amateur')
        for(let result of results){
  
          contentMobile += `<div class="smx-acc-item">`
          contentMobile += `  <div class="smx-acc-trigger">`
          contentMobile += `    <div class="smx-acc-col">${result.OverallPos}</div>`
          contentMobile += `    <div class="smx-acc-col">${result.Comp}</div>`
          contentMobile += `    <div class="smx-acc-col">${result.FullName}</div>`
          contentMobile += `    <div class="smx-acc-col">${result.Bike}</div>`
          contentMobile += `    <i class="fas fa-caret-down"></i>`
          contentMobile += `  </div>`
          contentMobile += `  <div class="smx-acc-content">`
          contentMobile += `    <div class="wrapper">`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">QUAL</div>`
          contentMobile += `        <div class="value">${result.Race1Grid}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Start | HS M1</div>`
          contentMobile += `        <div class="value">${result.Race1Start}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Laps Led M1</div>`
          contentMobile += `        <div class="value">${result.Race1LapsLed}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Finish M1</div>`
          contentMobile += `        <div class="value">${result.Race1Pos}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Points</div>`
          contentMobile += `        <div class="value">${result.Points}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Sponsors</div>`
          contentMobile += `        <div class="value">${result.Sponsors}</div>`
          contentMobile += `      </div>`
          contentMobile += `    </div>`
          contentMobile += `  </div>`
          contentMobile += `</div>`
          
          contentDesktop += `<div class="smx-table-body-row">`
          contentDesktop += `  <div class="smx-table-body-col col-s">${result.OverallPos}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-s">${result.Comp}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-l">${result.FullName}</div>`
          contentDesktop += `  <div class="smx-table-body-col  col-l">${result.Bike}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race1Grid}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race1Start}</div>`
          // contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race2Start}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race1LapsLed}</div>`
          // contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race2LapsLed}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race1Pos}</div>`
          // contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race2Pos}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Points}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-l">${result.Sponsors}</div>`
          contentDesktop += `</div>`
  
        }
      } else{
        for(let result of results){
  
          contentMobile += `<div class="smx-acc-item">`
          contentMobile += `  <div class="smx-acc-trigger">`
          contentMobile += `    <div class="smx-acc-col">${result.OverallPos}</div>`
          contentMobile += `    <div class="smx-acc-col">${result.Comp}</div>`
          contentMobile += `    <div class="smx-acc-col">${result.FullName}</div>`
          contentMobile += `    <div class="smx-acc-col">${result.Bike}</div>`
          contentMobile += `    <i class="fas fa-caret-down"></i>`
          contentMobile += `  </div>`
          contentMobile += `  <div class="smx-acc-content">`
          contentMobile += `    <div class="wrapper">`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">QUAL</div>`
          contentMobile += `        <div class="value">${result.Race1Grid}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Start | HS M1</div>`
          contentMobile += `        <div class="value">${result.Race1Start}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Start | HS M2</div>`
          contentMobile += `        <div class="value">${result.Race2Start}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Laps Led M1</div>`
          contentMobile += `        <div class="value">${result.Race1LapsLed}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Laps Led M2</div>`
          contentMobile += `        <div class="value">${result.Race2LapsLed}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Finish M1</div>`
          contentMobile += `        <div class="value">${result.Race1Pos}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Finish M2</div>`
          contentMobile += `        <div class="value">${result.Race2Pos}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Points</div>`
          contentMobile += `        <div class="value">${result.Points}</div>`
          contentMobile += `      </div>`
          contentMobile += `      <div class="smx-acc-row">`
          contentMobile += `        <div class="label">Sponsors</div>`
          contentMobile += `        <div class="value">${result.Sponsors}</div>`
          contentMobile += `      </div>`
          contentMobile += `    </div>`
          contentMobile += `  </div>`
          contentMobile += `</div>`
          
          contentDesktop += `<div class="smx-table-body-row">`
          contentDesktop += `  <div class="smx-table-body-col col-s">${result.OverallPos}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-s">${result.Comp}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-l">${result.FullName}</div>`
          contentDesktop += `  <div class="smx-table-body-col  col-l">${result.Bike}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race1Grid}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race1Start}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race2Start}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race1LapsLed}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race2LapsLed}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race1Pos}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Race2Pos}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-m">${result.Points}</div>`
          contentDesktop += `  <div class="smx-table-body-col col-l">${result.Sponsors}</div>`
          contentDesktop += `</div>`
  
        }

      }

      containerMobile.html(contentMobile)
      containerDesktop.html(contentDesktop)
    }
    
    $.ajax( {
      url: `https://data-aws.amaproracing.com/api/overallresults/latest/XC/${eventID}`,
      method: 'GET',
      dataType: 'json',
      error: () => error(),
      success: data => {
        console.log(data)
        render(data)
        acc()
        loaded('#hbh-overall')
      }
    });

  }

}